module.exports = __webpack_public_path__ + "media/img/pages/companies/invest-neuchatel-3af998f79507d212914b8d9f591707a7.png";